import React, { Component } from "react";
import { Bar } from "react-chartjs-2";

class ChartwidgetCanvas4 extends Component {
	render() {
	 
    const data = {
		defaultFontFamily: 'Poppins',
		 labels: ["MART", "RAW", "LENNAR", "DMT", "SNOWFLAKE"],
		datasets: [{
            label: 'Classified',
            backgroundColor: '#fff',
            hoverBackgroundColor: '#eee', 
            barPercentage: 0.5, 
            data: [
                '334',
                '422',
                '609',
                '1000',
                '225'
            ]
        }, {
            label: 'Not Classified',
            backgroundColor: 'rgba(255,255,255,0.1)',
            hoverBackgroundColor: 'rgba(255,255,255,0.15)', 
            barPercentage: 0.5, 
            data: [
                '600',
                '450',
                '890',
                '1300',
                '230'
            ]
        }]
    };

    const options = {
      plugins: {        
        legend: {
          display: false
        }, 
      },
		title: {
			display: false
		},
		tooltips: {
			mode: 'index',
			intersect: false
		},
		responsive: true,
		maintainAspectRatio: false, 
		scales: {
			x: {
				display: false, 
				stacked: true,
				
				ticks: {
					display: false
				}, 
				grid: {
					display: false, 
					drawBorder: false
				}
			},
			y: {
				display: false, 
				stacked: true, 
				grid: {
					display: false, 
					drawBorder: false
				}, 
				ticks: {
					display: false
				}
			}
		}
      
    };

    return (
      <div >
        <Bar
          data={data}
         // width={this.props.width ? this.props.width : 433}
          height={this.props.height ? this.props.height : 270}
          options={options}
        />
      </div>
    );
  }
}

export default ChartwidgetCanvas4;
